import { createGlobalState } from 'react-use';
import { useCallback } from 'react';

type AiAssistantPhoneConnectionGlobalState = { connected: boolean };

const useGlobalState = createGlobalState<AiAssistantPhoneConnectionGlobalState>({ connected: false });

type ConnectCallback = VoidFunction;
type ResetCallback = VoidFunction;

type UseAiAssistantPhoneConnectionGlobalStateReturnFn = {
   connected: boolean;
   connect: ConnectCallback;
   reset: ResetCallback;
};

export const useAiAssistantPhoneConnectionGlobalState = (): UseAiAssistantPhoneConnectionGlobalStateReturnFn => {
   const [state, setState] = useGlobalState();

   const connect = useCallback<ConnectCallback>(() => {
      setState((prev) => (prev.connected ? prev : { connected: true }));
   }, [setState]);

   const reset = useCallback<ResetCallback>(() => {
      setState((prev) => (prev.connected ? { connected: false } : prev));
   }, [setState]);

   return {
      connected: state.connected,
      connect: connect,
      reset: reset,
   };
};
